import { useQuery } from "@tanstack/react-query";
import { CalendarClock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { api } from "../lib/api";

export function ProbationWidget() {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const le = params.get("le") ?? "";

  const { data, isLoading, error } = useQuery({
    queryKey: ["probation-ending-soon", le],
    queryFn: () => api.getProbationEndingSoon(le, 30),
    enabled: !!le,
    staleTime: 60_000,
  });

  if (!le || isLoading || error || !data || data.items.length === 0) {
    return null;
  }

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start justify-between">
        <div>
          <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-amber-900">
            <CalendarClock className="h-3.5 w-3.5" />
            {t("app.prob_widget_title")}
          </p>
          <p className="mt-1 text-sm text-amber-900">
            {t(
              data.items.length === 1
                ? "app.prob_widget_body_one"
                : "app.prob_widget_body_many",
              { count: data.items.length, days: data.days_window },
            )}
          </p>
        </div>
      </div>

      <ul className="mt-3 divide-y divide-amber-200 text-sm">
        {data.items.slice(0, 5).map((it) => (
          <li
            key={it.contract_id}
            className="flex items-center justify-between py-1.5"
          >
            <Link
              to={`/employees/${it.employee_id}`}
              className="font-medium text-amber-900 hover:underline"
            >
              {it.employee_first_name_en} {it.employee_last_name_en}{" "}
              <span className="text-xs font-normal text-amber-700">
                ({it.employee_code})
              </span>
            </Link>
            <span className="font-mono text-xs text-amber-700 tabular-nums">
              {t("app.prob_widget_days_short", { n: it.days_remaining })} · {it.probation_end_date}
            </span>
          </li>
        ))}
      </ul>
      {data.items.length > 5 && (
        <p className="mt-2 text-xs text-amber-700">
          {t("app.prob_widget_more", { n: data.items.length - 5 })}
        </p>
      )}
    </div>
  );
}
